import { Injectable } from '@angular/core';
import { NotificationDTO, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { tap } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmContactDialogComponent } from '@shared/confirm-contact-dialog/confirm-contact.component';
import { LOADS_SOURCING } from '../../loads-sourcing/store/actions';
import { Store } from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class CarrierService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private dialog: MatDialog,
		private store: Store
	) {}

	get(quoteId: string, carrierData: any) {
		const url = this.urlService.getCarrierForBid(quoteId, carrierData);
		return this.restService.GET(url);
	}

	getContactsInfo(carrier: any, carrierData: any): any {
		let contact = {
			carrierName: '',
			contactEmail: '',
			contactPhone: '',
		};
		if (carrier.contacts != undefined && carrier.contacts != null && carrier.contacts.length > 0) {
			var contacts = carrier.contacts.filter(function (contact) {
				return contact.primaryContact;
			});
			if (contacts.length > 0) {
				if (carrierData.carrierName == undefined || carrierData.carrierName == null) {
					contact.carrierName =
						(contacts[0].firstName || '') + ' ' + (contacts[0].lastName || '') || '';
				}

				if (carrierData.contactEmail == undefined || carrierData.contactEmail == null) {
					contact.contactEmail = contacts[0].emailAddress || '';
				}

				if (carrierData.contactPhone == undefined || carrierData.contactPhone == null) {
					contact.contactPhone = contacts[0].phone || '';
				}
			}
		}
		return contact;
	}

	create(quoteId: string, carrierData: any) {
		const url = this.urlService.createCarrierForBid(quoteId);
		return this.restService.POST(url, carrierData);
	}

	search(url: string) {
		return this.restService.GET(url).pipe(
			tap((response: any) => {
				return response;
			})
		);
	}

	confirmContact(notification: NotificationDTO) {
		this.dialog.open(ConfirmContactDialogComponent, {
			width: '600px',
			disableClose: true,
			data: { ...notification },
		});
	}

	carrierRequestedOnboarding(
		carrierId: string,
		brokerAccountId: number,
		brokerUserId: number,
		integrationType: string,
		availableLoad: any
	) {
		const url: string = this.urlService.carrierRequestedOnboarding(
			carrierId,
			brokerAccountId,
			brokerUserId,
			integrationType
		);
		this.restService.POST(url, {}).subscribe(
			(_) => {
				if (availableLoad) {
					const availableLoadCopy = { ...availableLoad };
					availableLoadCopy['carrier_requested_onboarding_at'] = Date.now();
					this.store.dispatch(LOADS_SOURCING.LOADS_LIST.UPDATE({ updatedLoad: availableLoadCopy }));
				}
			},
			(error) => {
				console.error('Could not notify broker about carrier onboarding', error);
			}
		);
	}
}
